import { useAxios } from '@/context/axiosContext'
import { GolfBizNm, GolfInfoData } from '@/pages/promotion/promotionItem'
import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import {
  CommentListData,
  FeedbackDetailData,
  formatDateString,
  PreviewIcon,
} from '../feedbackItem'
import { Badge, Button } from '@/components'
import { Viewer } from '@toast-ui/react-editor'
import commonUtils from '@/utils/commonUtils'
import useCopyToClipboard from '@/hooks/useCopyToClipboard'
import { useAppSelector } from '@/redux/hooks'
import { useDialog } from '@/context/dialogContext'
import {
  buttonName,
  confirmMessages,
  getFeedbackBadgeClass,
  getFeedbackBadgeLabel,
  getMobileBadgeClass,
  getPromoBadgeLabel,
  successMessages,
  withDrawnCumtomer,
} from '@/pages/board/boardItem'
import '../feedback.css'
import { MenuHeader } from '@/pages/menu/menuHeader'
import { UpdateFeedback } from './updateFeedback'
import { Comments } from './comments'
import LikeButton from './likeButton'
import { useResponsive } from '@/hooks/useResponsive'

interface CommentData {
  cmpnyCd: string
  nttSn: number
}

export const DetailFeedback = () => {
  const axios = useAxios()
  const location = useLocation()
  const navigate = useNavigate()
  const { user } = useAppSelector((state) => state.auth)
  const [isCopied, copyToClipboard] = useCopyToClipboard()
  const [isEditMode, setIsEditMode] = useState(false)
  const { showAlert, showConfirm } = useDialog()
  const [searchParams] = useSearchParams() // 쿼리 파라미터 사용
  const nttSn = Number(searchParams.get('nttSn')) // 게시판 번호
  const commentRef = useRef<HTMLDivElement>(null)
  const menuInfoRef = useRef<HTMLDivElement | null>(null)
  const [hasMenuInfo, setHasMenuInfo] = useState<boolean>(true)
  const [commentList, setCommentList] = useState<CommentListData[]>([])
  const [commentListCnt, setCommentListCnt] = useState(0)
  const [nameList, setNameList] = useState<GolfBizNm[]>([])
  const { isMobile, isTablet, isDesktop } = useResponsive()
  const [fileList, setFileList] = useState<
    {
      fileSeq: number
      fileName: string
      fileSource: string
      fileOrgName: string
    }[]
  >([])
  const [detailData, setDetailData] = useState<FeedbackDetailData>({
    cmpnyCd: '',
    cstId: '',
    nttSn: 0,
    regId: '',
    regDate: '',
    updId: '',
    updDate: '',
    fdbkType: '',
    bizCd: '',
    bizNm: '',
    nttSj: '',
    nttCn: '',
    rndDt: '',
    email: '',
    adminDelYn: '',
    delYn: '',
    useYn: '',
    nickName: '',
    withDrawYn: '',
    deleteFileSeqList: [],
    fileNameList: [],
    fileSeqList: [],
    fileSourceList: [],
    likesYn: '',
    likeCnt: 0,
    fileName: [],
    fileOrgName: [],
    fileSeq: [],
  })

  const withDrawYn = detailData?.withDrawYn === 'Y'

  useEffect(() => {
    if (nttSn) {
      getFeedbackDetail()
      getCommentList()
    }
  }, [nttSn])

  useEffect(() => {
    window.scrollTo(0, 0) // behavior: 'smooth' 없이 즉시 이동
  }, [])

  useEffect(() => {
    setDetailData((prevData) => ({
      ...prevData,
      fileSeqList: fileList.map((file) => file.fileSeq),
      fileNameList: fileList.map((file) => file.fileName),
      fileSourceList: fileList.map((file) => file.fileSource),
      fileName: fileList
        .filter((file) => file.fileSource?.toLowerCase() === 'upload')
        .map((file) => `${file.fileName}`),
      fileOrgName: fileList
        .filter((file) => file.fileSource?.toLowerCase() === 'upload')
        .map((file) => `${file.fileOrgName}`),
      fileSeq: fileList
        .filter((file) => file.fileSource?.toLowerCase() === 'upload')
        .map((file) => Number(`${file.fileSeq}`)),
    }))
  }, [fileList])

  // useEffect(() => {
  //   console.log('fileSeqList', detailData.fileSeqList)
  //   console.log('fileNameList', detailData.fileNameList)
  //   console.log('fileSourceList', detailData.fileSourceList)
  // }, [
  //   detailData.fileSeqList,
  //   detailData.fileNameList,
  //   detailData.fileSourceList,
  // ])

  const getFeedbackDetail = async () => {
    try {
      const response = await axios.get(`/feedback/detail`, {
        headers: { 'Cache-Control': 'no-cache' },
        params: { nttSn },
      })

      const { feedbackDetail, fileList, golfNameList } = response?.data?.data

      const htmlContent = feedbackDetail.nttCn
      const imgUrls = extractImageUrls(htmlContent)

      setDetailData(feedbackDetail)

      const fileInfoList = fileList.map((file: any, index: number) => {
        return {
          fileName: file.fdbkFileName,
          fileSeq: file.fdbkFileSeq,
          fileSource: file.fdbkFileSource,
          fileOrgName: file.fdbkFileOrgName,
        }
      })

      // const uploadFileUrl = fileList
      //   .filter((file: any) => file.fdbkFileSource?.toLowerCase() === 'upload')
      //   .map((file: any) => {
      //     return {
      //       fileName: file.fdbkFileName,
      //       fileUrl: `/upload/images/${file.fdbkFileName}`, // 실제 경로 조합
      //     }
      //   })

      const seenBizCds = new Set<string>()
      const golfList: GolfBizNm[] = golfNameList
        .filter((item: GolfInfoData) => {
          const isValid = item.remark?.trim()
          const isUnique = !seenBizCds.has(item.bizCd || '')
          if (isValid && isUnique) {
            seenBizCds.add(item.bizCd || '')
            return true
          }
          return false
        })
        .map((item: GolfInfoData) => ({
          areaCd: item.areaCd?.trim(),
          bizNm: item.bizNm?.trim(),
          bizCd: item.bizCd,
        }))

      setFileList(fileInfoList)
      setNameList(golfList)
    } catch (err: any) {
      console.error('Error fetching detailBlog:', err)
    }
  }

  const getCommentList = async () => {
    try {
      const data: CommentData = {
        cmpnyCd: '001',
        nttSn: nttSn,
      }

      const response = await axios.get(`/feedback/comment/list`, {
        params: { ...data },
      })

      const { commentList } = response.data.data

      if (Array.isArray(commentList)) {
        setCommentList(commentList)
        setCommentListCnt(commentList?.length)
      }
    } catch (err: any) {
      console.error('Error fetching commentList:', err)
    }
  }

  const extractImageUrls = (htmlContent: string) => {
    const imgUrls = Array.from(
      new DOMParser()
        .parseFromString(htmlContent, 'text/html')
        .querySelectorAll('img'),
    ).map((img) => {
      const imgSrc = img.src
      const filePath = imgSrc.split('upload')[1]
      return decodeURIComponent(filePath)
    })
    return imgUrls
  }

  const scrollToComment = () => {
    commentRef.current?.scrollIntoView({
      behavior: 'smooth', // 부드러운 스크롤
    })
  }

  const handleCopy = () => {
    const url = window.location.href // 현재 페이지 URL
    copyToClipboard(url)
  }

  const handleModalAction = (type: 'update' | 'delete' | 'cancel') => {
    if (type === 'update') {
      showConfirm({
        title: confirmMessages.update,
        confirmBtnName: buttonName.confirm,
        cancelBtnName: buttonName.cancel,
        onConfirm() {
          setIsEditMode(true)
        },
      })
    }

    if (type === 'delete') {
      showConfirm({
        title: confirmMessages.delete,
        confirmBtnName: buttonName.confirm,
        cancelBtnName: buttonName.cancel,
        onConfirm() {
          deleteFeedback()
        },
      })
    }

    if (type === 'cancel') {
      showConfirm({
        title: confirmMessages.cancel,
        confirmBtnName: buttonName.confirm,
        cancelBtnName: buttonName.cancel,
        onConfirm() {
          setTimeout(() => {
            navigate(0) // 500ms 후에 페이지 이동
          }, 100)
        },
      })
    }
  }

  const deleteFeedback = async () => {
    try {
      await axios.post(`/feedback/delete`, { nttSn })

      showAlert({
        type: 'success',
        title: successMessages.delete,
        btnName: buttonName.confirm,
        onClose() {
          setTimeout(() => {
            navigate(`/feedback`)
          }, 100)
        },
      })
    } catch (err: any) {
      console.error('Error fetching detailBlog:', err)
    }
  }

  const filePreview = (fileName: string) => {
    window.open(
      process.env.REACT_APP_BASE_URL + `/upload/${fileName}`,
      '_blank',
    )
  }

  return (
    <>
      {!isEditMode ? (
        <>
          {!isMobile ? (
            <>
              <MenuHeader
                pathName={location.pathname}
                showWriteButton={true}
                menuInfoRef={menuInfoRef}
                loginRequired={true}
              />
              <div className="feedback-detail-wrapper">
                <div className="feedback-detail-box">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div>
                      <Badge
                        color={
                          detailData.fdbkType === '01' ? 'success' : 'danger'
                        }
                        marginRight={'4px'}
                        padding={'5px'}
                      >
                        <span style={{ fontWeight: 'bold', fontSize: '11px' }}>
                          {detailData.fdbkType === '01' ? '꿀소리' : '쓴소리'}
                        </span>
                      </Badge>
                      <Badge color="neverbe" padding={'5px'}>
                        <span style={{ fontWeight: 'bold', fontSize: '11px' }}>
                          {detailData.bizNm}
                        </span>
                      </Badge>
                    </div>
                    <div
                      style={{ color: 'rgb(208, 157, 48)', fontWeight: 'bold' }}
                    >
                      {`라운드날짜 : ${formatDateString(detailData.rndDt)}`}
                    </div>
                  </div>
                  <div className="feedback-detail-title">
                    {detailData?.nttSj}
                  </div>
                  <div className="feedback-detail-meta">
                    <div className="feedback-detail-top">
                      <div>
                        <div>
                          작성자 :&nbsp;
                          {detailData?.nickName}
                          &nbsp;
                        </div>
                        <div className="feedback-detail-sub">
                          <div>
                            작성일 :&nbsp;
                            {detailData?.regDate
                              ? commonUtils.formatDate(detailData.regDate, true)
                              : ''}
                          </div>
                          <div className="feedback-divider" />
                          <div>조회 : {detailData?.readngCnt}</div>
                        </div>
                      </div>
                      <div className="feedback-url-copy">
                        <LikeButton
                          likesYn={detailData.likesYn}
                          likeCnt={detailData.likeCnt}
                          nttSn={detailData.nttSn}
                          fdbkType={detailData.fdbkType}
                        />
                        <div
                          style={{
                            margin: '0 8px',
                            borderLeft: '1px solid #ddd',
                            height: '16px',
                          }}
                        />
                        <div
                          style={{ cursor: 'pointer' }}
                          onClick={scrollToComment}
                        >
                          댓글 [{commentListCnt}]
                        </div>

                        <div
                          style={{
                            margin: '0 8px',
                            borderLeft: '1px solid #ddd',
                            height: '16px',
                          }}
                        />

                        <span onClick={handleCopy}>URL복사</span>
                      </div>
                    </div>
                  </div>
                  <div className="feedback-detail-divider" />
                  {detailData.fileOrgName?.[0] && (
                    <div
                      className="file-wrapper"
                      onClick={() => filePreview(detailData?.fileName?.[0])} // 첫 번째 파일만
                    >
                      <PreviewIcon />
                      <span>첨부파일 :</span>
                      <span>&nbsp;{detailData.fileOrgName?.[0]}</span>
                    </div>
                  )}
                  <div className="feedback-detail-content">
                    <Viewer
                      key={detailData.nttSn}
                      initialValue={detailData.nttCn}
                    />
                  </div>
                </div>
                <div className="feedback-detail-button-wrap">
                  <div className="feedback-button-group">
                    <div className="feedback-button-row">
                      {user?.cstId === detailData?.regId ? (
                        <>
                          <Button
                            color="neverbe"
                            onClick={() => handleModalAction('update')}
                          >
                            수정
                          </Button>
                          <Button
                            color="neverbe"
                            onClick={() => handleModalAction('delete')}
                          >
                            삭제
                          </Button>
                          <Button
                            color="neverbe"
                            onClick={() =>
                              navigate(`/feedback`, { state: location.state })
                            }
                          >
                            목록
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            color="neverbe"
                            onClick={() =>
                              navigate(`/feedback`, { state: location.state })
                            }
                          >
                            목록
                          </Button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <Comments
                  withDraw={detailData?.withDrawYn}
                  commentListCnt={commentListCnt}
                  commentRef={commentRef}
                  scrollToComment={scrollToComment}
                  nttSn={nttSn}
                  commentList={commentList}
                  cstId={user?.cstId}
                  nickName={user?.nickName}
                  getCommentList={getCommentList}
                />
              </div>
            </>
          ) : (
            <div className="mobile-view">
              <div className="mobile-post-detail-container">
                <div className="mobile-post-detail-header">
                  <h1
                    className="mobile-post-detail-title"
                    onClick={() => {
                      navigate(`/promotion`)
                    }}
                  >
                    목소리
                  </h1>
                  <button className="mobile-url-copy-btn" onClick={handleCopy}>
                    URL복사
                  </button>
                </div>
                <div className="mobile-post-card" key={detailData?.nttSn}>
                  <div className="mobile-post-card-header">
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        justifyItems: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <div>
                        <span
                          className={getFeedbackBadgeClass(
                            detailData?.fdbkType || '01',
                          )}
                        >
                          {getFeedbackBadgeLabel(detailData.fdbkType)}
                        </span>
                        &nbsp;
                        <span className={getMobileBadgeClass('99')}>
                          {detailData.bizNm}
                        </span>
                        &nbsp;
                      </div>
                      <LikeButton
                        likesYn={detailData.likesYn}
                        likeCnt={detailData.likeCnt}
                        nttSn={detailData.nttSn}
                        fdbkType={detailData.fdbkType}
                        isMobile={isMobile}
                      />
                    </div>
                    <h2 className="mobile-post-card-title">
                      {detailData?.nttSj}
                    </h2>
                    <div className="mobile-post-card-meta">
                      <div className="mobile-post-card-meta-row">
                        <span style={{ color: '#d09D03', fontWeight: 'bold' }}>
                          &nbsp;
                          {withDrawYn
                            ? withDrawnCumtomer.name
                            : detailData?.nickName}
                        </span>
                        <span>views {detailData?.readngCnt}</span>
                      </div>
                      <div className="mobile-post-card-meta-row">
                        <span>
                          &nbsp;
                          {detailData?.regDate
                            ? commonUtils.formatDate(detailData.regDate, true)
                            : ''}
                        </span>
                      </div>
                    </div>
                  </div>
                  {detailData.fileOrgName?.[0] && (
                    <div
                      className="file-wrapper"
                      style={{ marginRight: '10px', marginTop: '10px' }}
                      onClick={() => filePreview(detailData?.fileName?.[0])} // 첫 번째 파일만
                    >
                      <PreviewIcon />
                      <span>첨부파일 :</span>
                      <span>&nbsp;{detailData.fileOrgName?.[0]}</span>
                    </div>
                  )}
                  <div className="mobile-post-card-content">
                    <Viewer
                      key={detailData.nttSn}
                      initialValue={detailData.nttCn}
                    />
                  </div>
                </div>
                <Comments
                  withDraw={detailData?.withDrawYn}
                  commentListCnt={commentListCnt}
                  commentRef={commentRef}
                  scrollToComment={scrollToComment}
                  nttSn={nttSn}
                  commentList={commentList}
                  cstId={user?.cstId}
                  nickName={user?.nickName}
                  getCommentList={getCommentList}
                />
                <div className="mobile-post-actions">
                  <button
                    className="mobile-action-btn primary"
                    onClick={() =>
                      navigate(`/feedback`, { state: location.state })
                    }
                  >
                    목록으로
                  </button>
                  {(user?.userId === detailData?.regId ||
                    user?.cstId === detailData?.regId) && (
                    <>
                      <button
                        className="mobile-action-btn user"
                        onClick={() => handleModalAction('update')}
                      >
                        수정
                      </button>
                      <button
                        className="mobile-action-btn user"
                        onClick={() => handleModalAction('delete')}
                      >
                        삭제
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <UpdateFeedback
          nttSn={nttSn}
          nttSj={detailData?.nttSj}
          nttCn={detailData?.nttCn}
          bizCd={detailData?.bizCd}
          fdbkType={detailData?.fdbkType}
          rndDt={detailData.rndDt}
          email={detailData.email}
          detailFileList={fileList}
          nameList={nameList}
          fileOrgName={detailData?.fileOrgName?.[0] || ''}
          fileSeq={detailData?.fileSeq[0]}
        />
      )}
    </>
  )
}
